<template>
  <div>
    <div class="m_context plr">
      <el-row>
        <el-col :span="24" v-if="!isEdit">
          <el-form ref="addForm" id="addForm" :model="form" :rules="rules" label-width="12.5%">
            <el-form-item :label="$t('lin_global.userName')" prop="userName">
              <el-input id="userName" v-model="form.userName"></el-input>
            </el-form-item>

            <el-form-item :label="$t('lin_global.password')" prop="password">
              <el-input type="password" v-model="form.password" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item :label="$t('lin_global.comfirmPass')" prop="password1">
              <el-input type="password" v-model="form.password1" auto-complete="off"></el-input>
            </el-form-item>

            <el-form-item :label="$t('lin_global.nickName')" prop="nickName">
              <el-input id="nickName" v-model="form.nickName"></el-input>
            </el-form-item>

            <el-form-item :label="$t('lin_global.phoneNum2')" prop="phoneNum">
              <el-input id="phoneNum" v-model="form.phoneNum"></el-input>
            </el-form-item>

            <el-form-item :label="$t('app_allowiplg')" prop>
              <div>
                <el-input v-model="ip1" style="width:80px"></el-input>
                <label style="font-size:14px;margin 0 6px 0 6px">.</label>
                <el-input v-model="ip2" style="width:80px"></el-input>
                <label style="font-size:14px;margin 0 6px 0 6px">.</label>
                <el-input v-model="ip3" style="width:80px"></el-input>
                <label style="font-size:14px;margin 0 6px 0 6px">.</label>
                <el-input v-model="ip4" style="width:80px"></el-input>
              </div>
              <div style="color:rgb(72,87,106);">{{$t('app_allowiptip')}}</div>
            </el-form-item>

            <el-form-item :label="$t('lin_global.roleName')" prop="roleid">
              <el-select id="roleid" v-model="form.roleid" filterable clearable class="w_33">
                <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName" :value="item.roleId"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('lin_global.label_areaid')" prop="mechanismId" v-show="!mcid">
              <!--<el-select id="mechanismId" v-model="form.mechanismId" filterable clearable :placeholder="$t('lin_global.place_areaid')" class="w_33">-->
              <!--<el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">-->
              <!--</el-option>-->
              <!--</el-select>-->

              <MechanismSelector :data="mechanismData" :mselect="true"></MechanismSelector>
            </el-form-item>
            <el-form-item v-show="showut" :label="$t('app_usertype')" prop>
              <el-radio-group v-model="form.userType">
                <el-radio :label="1">{{$t('app_distributor')}}</el-radio>
                <el-radio :label="2">{{$t('app_developer')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('lin_global.status')" prop>
              <el-radio-group v-model="form.userStatus">
                <el-radio :label="0">{{$t('lin_global.jh')}}</el-radio>
                <el-radio :label="1">{{$t('lin_global.dj')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button @click="onCancel" id="onCancel">{{$t('lin_btn.cancel')}}</el-button>
              <el-button type="primary" @click="onSubmit">{{$t('lin_btn.add')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="24" v-if="isEdit">
          <el-button type="primary" @click="dialogFormVisible = true">{{$t('lin_global.resetPass')}}</el-button>
          <el-form
            v-loading="loading"
            ref="addForm"
            id="addForm"
            :model="formEdit"
            :rules="rules"
            label-width="12.5%"
            class="mt20"
          >
            <el-form-item :label="$t('lin_global.userName')" prop="userName">
              <el-input id="userName" v-model="formEdit.userName"></el-input>
            </el-form-item>

            <!--  <el-form-item label="密码" prop="pass">
				    <el-input type="password" v-model="ruleForm2.pass" auto-complete="off"></el-input>
            </el-form-item>-->

            <el-form-item :label="$t('lin_global.nickName')" prop="nickName">
              <el-input id="nickName" v-model="formEdit.nickName"></el-input>
            </el-form-item>

            <el-form-item :label="$t('lin_global.phoneNum2')" prop="phoneNum">
              <el-input id="phoneNum" v-model="formEdit.phoneNum"></el-input>
            </el-form-item>

            <el-form-item :label="$t('app_allowiplg')" prop>
              <div>
                <el-input v-model="ip1" style="width:80px"></el-input>
                <label style="font-size:14px;margin 0 6px 0 6px">.</label>
                <el-input v-model="ip2" style="width:80px"></el-input>
                <label style="font-size:14px;margin 0 6px 0 6px">.</label>
                <el-input v-model="ip3" style="width:80px"></el-input>
                <label style="font-size:14px;margin 0 6px 0 6px">.</label>
                <el-input v-model="ip4" style="width:80px"></el-input>
              </div>
              <div style="color:rgb(72,87,106);">{{$t('app_allowiptip')}}</div>
            </el-form-item>

            <el-form-item :label="$t('lin_global.roleName')" prop="roleid">
              <el-select id="roleid" v-model="formEdit.roleid" filterable clearable class="w_33">
                <el-option v-for="item in roleList" :key="item.roleId" :label="item.roleName" :value="item.roleId"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('lin_global.label_areaid')" prop="mechanismId">
              <!--<el-select id="mechanismId" v-model="formEdit.mechanismId" filterable clearable :placeholder="$t('lin_global.place_areaid')" class="w_33">-->
              <!--<el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">-->
              <!--</el-option>-->
              <!--</el-select>-->

              <MechanismSelector :data="mechanismDataUpdate" :mselect="true"></MechanismSelector>
            </el-form-item>
            <el-form-item v-show="showut" :label="$t('app_usertype')" prop>
              <el-radio-group v-model="formEdit.userType">
                <el-radio :label="1">{{$t('app_distributor')}}</el-radio>
                <el-radio :label="2">{{$t('app_developer')}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('lin_global.status')" prop="userStatus">
              <el-radio-group v-model="formEdit.userStatus">
                <el-radio :label="0">{{$t('lin_global.jh')}}</el-radio>
                <el-radio :label="1">{{$t('lin_global.dj')}}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item>
              <el-button @click="onCancel" id="onCancel">{{$t('lin_btn.cancel')}}</el-button>
              <el-button type="primary" @click="onSubmitEdit">{{$t('lin_btn.change')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      class="gDia"
      :title="$t('lin_global.revisePass')"
      v-model="dialogFormVisible"
      size="tiny"
    >
      <el-form :model="formPwd" :rules="rules2" ref="formPwd">
        <!-- <el-form-item :label="$t('lin_global.oldPass')" :label-width="formLabelWidth"> 
      <el-input v-model="formPwd.oldPass" type="password" auto-complete="off"></el-input> 
        </el-form-item>-->
        <el-form-item :label="$t('lin_global.newPass')" :label-width="formLabelWidth" prop="pass">
          <el-input v-model="formPwd.pass" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('lin_global.comfirmPass')"
          :label-width="formLabelWidth"
          prop="checkPass"
        >
          <el-input v-model="formPwd.checkPass" type="password" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{$t('lin_btn.cancel')}}</el-button>
        <el-button type="primary" @click="submitForm('formPwd')">{{$t('lin_btn.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
var md5 = require("md5");
import axios from "axios";
import { baseurl } from "../../api/url";
import MechanismSelector from "@/components/global/mechanism_selector.vue";
export default {
  components: {
    MechanismSelector
  },
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lin_global.plePassTips")));
      } else {
        if (this.formPwd.checkPass !== "") {
          this.$refs.formPwd.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      var reg=/^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_])).{8,}$/
      if (value === "") {
        callback(new Error(this.$t("lin_global.plePassTipsAgain")));
      } else if (value !== this.formPwd.pass) {
        callback(new Error(this.$t("lin_global.pwdDisfault")));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t("app_pswtip")));
      } else {
        callback();
      }
    };
    var phoneCheck = (rule, value, callback) => {
      if (!this.isLegalMobile(value)) {
        callback(new Error(this.$t("lin_global.unfitPhone")));
      } else {
        callback();
      }
    };

    var that = this;
    return {
      mechanismData: {
        value: null,
        placeholder: that.$t("lin_global.place_areaid"),
        callback(value) {
          that.form.mechanismId = value;
        }
      },
      mechanismDataUpdate: "",
      dialogFormVisible: false,
      formLabelWidth: "100px",
      mcid: "",
      ip1: "",
      ip2: "",
      ip3: "",
      ip4: "",
      formPwd: {
        oldPass: "",
        pass: "",
        checkPass: ""
      },
      loading: true,
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      form: {
        nickName: "",
        userName: "",
        phoneNum: "",
        password: "",
        password1: "",
        roleid: "",
        userType: 1,
        mechanismId: "",
        userStatus: 0,
        token: localStorage.getItem("user")
      },
      formEdit: {
        nickName: "",
        userName: "",
        phoneNum: "",
        userType: 1,
        roleid: "",
        mechanismId: "",
        userStatus: 0,
        userid: this.$route.params.id
      },
      isEdit: false,
      rules: {
        nickName: [
          {
            required: true,
            message: this.$t("lin_global.nickNameTips")
          }
        ],
        password: [
          {
            required: true,
            message: this.$t("lin_global.passWordTips")
          }
        ],
        password1: [
          {
            required: true,
            message: this.$t("lin_global.comfirmPass")
          }
        ],
        userName: [
          {
            required: true,
            message: this.$t("lin_global.userNameTips")
          }
        ],
        phoneNum: [
          {
            required: true,
            message: this.$t("lin_global.phoneNumTips")
          } /*,{
            validator: phoneCheck, trigger: 'blur'
          }*/
        ],
        roleid: [
          {
            required: true,
            message: this.$t("lin_global.roleidTips")
          }
        ],
        mechanismId: [
          {
            required: true,
            message: this.$t("lin_global.mechanismIdTips")
          }
        ],
        userStatus: [
          {
            required: true,
            message: this.$t("lin_global.userStatusTips")
          }
        ]
      },
      areaList: [],
      roleList: []
    };
  },
  created() {
    // 渠道商处加子号

    this.mcid = this.$getWObj().tmcid;
    if (this.mcid) {
      this.form.mechanismId = this.mcid;
    }

    // alert(this.tMechanismId)
    this.getAd();
    this.getRole();
    if (this.$route.params.id) {
      this.isEdit = true;
      //console.log('编辑页面');
      this.getInfo();
    } else {
      this.isEdit = false;
      //console.log("添加页面");
    }
  },
  props: {
    tMechanismId: String
  },
  computed: {
    showut() {
      var type = localStorage.userType;
      if (type == 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, "g");
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    chang: function() {
      //alert("nime")
      this.dialogFormVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var params = {
            userId: this.$route.params.id,
            password: md5(this.formPwd.checkPass)
          };
          //console.log("打印修改密码传参")

          axios.post(`${baseurl}/user/resetPass.do`, params).then(res => {
            //console.log("打印看看登陆信息")
            //console.log(res.data);
            if (res.data.status == 200) {
              this.dialogFormVisible = false;
              this.$message.success(res.data.message);
            } else {
              this.dialogFormVisible = false;
              this.$message.error(res.data.message);
            }
          });
        } else {
          //console.log('error submit!!');
          return false;
        }
      });
    },
    isLeggalipNum(num) {
      if (!num) {
        return true;
      }

      var rule = /^[0-9]\d*$/;
      if (rule.test(num)) {
        if (parseInt(num) > 255) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    addInfo: function() {
      if (
        !this.isLeggalipNum(this.ip1) ||
        !this.isLeggalipNum(this.ip2) ||
        !this.isLeggalipNum(this.ip3) ||
        !this.isLeggalipNum(this.ip4)
      ) {
        this.$message.error("IP" + this.$t("app_illegal"));
        return;
      }

      var params = this.form;
      //console.log("打印传入参数");
      //console.log(params)

      if (this.form.password !== this.form.password1) {
        this.$message.error(this.$t("lin_global.pwdDisfault"));
        return;
      }

      var ip1 = this.ip1 ? this.ip1 : "*";
      var ip2 = this.ip2 ? this.ip2 : "*";
      var ip3 = this.ip3 ? this.ip3 : "*";
      var ip4 = this.ip4 ? this.ip4 : "*";
      params.limitIp = ip1 + "," + ip2 + "," + ip3 + "," + ip4;

      axios.post(`${baseurl}/user/addUser.do`, params).then(res => {
        //console.log("打印看看登陆信息")
        //console.log(res.data);
        if (res.data.status == 200) {
          this.$message.success(res.data.message);
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    onSubmitEdit: function() {
      if (
        !this.isLeggalipNum(this.ip1) ||
        !this.isLeggalipNum(this.ip2) ||
        !this.isLeggalipNum(this.ip3) ||
        !this.isLeggalipNum(this.ip4)
      ) {
        this.$message.error("IP" + this.$t("app_illegal"));
        return;
      }

      var params = this.formEdit;
      //console.log("打印传入参数");
      //console.log(params)

      var ip1 = this.ip1 ? this.ip1 : "*";
      var ip2 = this.ip2 ? this.ip2 : "*";
      var ip3 = this.ip3 ? this.ip3 : "*";
      var ip4 = this.ip4 ? this.ip4 : "*";
      params.limitIp = ip1 + "," + ip2 + "," + ip3 + "," + ip4;

      axios.post(`${baseurl}/user/editUser.do`, params).then(res => {
        //console.log("打印看看登陆信息")
        //console.log(res.data);
        if (res.data.status == 200) {
          this.$message.success(res.data.message);
          this.$router.go(-1);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getInfo: function() {
      var userId = this.$route.params.id;
      var params = { userId: userId };
      axios.post(`${baseurl}/user/getUserById.do`, params).then(res => {
        //console.log(res.data.data)
        if (res.data.status == 200) {
          var dataip = res.data.data.limitIp;
          if (dataip) {
            var arr = dataip.split(".");
            this.ip1 = arr[0] == "*" ? "" : arr[0];
            this.ip2 = arr[1] == "*" ? "" : arr[1];
            this.ip3 = arr[2] == "*" ? "" : arr[2];
            this.ip4 = arr[3] == "*" ? "" : arr[3];
          }

          this.formEdit.nickName = res.data.data.nickName;
          this.formEdit.userName = res.data.data.userName;
          this.formEdit.phoneNum = res.data.data.phoneNum;
          this.formEdit.roleid = res.data.data.roleid;
          this.formEdit.mechanismId = res.data.data.mechanismId;
          this.formEdit.userType = res.data.data.userType;
          ////res.data.data.mechanismId;
          var that = this;
          this.mechanismDataUpdate = {
            value: res.data.data.mechanismName,
            callback(value) {
              that.formEdit.mechanismId = value;
            }
          };

          this.formEdit.userStatus = res.data.data.userStatus;
          this.loading = false;
        }
      });
    },
    onSubmit: function() {
      this.$refs["addForm"].validate(valid => {
        if (valid) {
          this.addInfo();
        } else {
          this.$message.error(this.$t("lin_global.refs"));
          return false;
        }
      });
    },
    getAd: function() {
      var params = { page: 1, rows: 10000 };
      axios.post(`${baseurl}/mechanism/list.do`, params).then(res => {
        this.areaList = res.data.data;
      });
    },
    getRole: function() {
      /*var params = {page:1,rows:10000,distributorid:""};
		    	axios.post(`${baseurl}/role/list.do`,params).then(res=>{
		    		this.roleList = res.data.data;
		    		console.log('rr', res.data.data)
		    	})*/
      this.$roleMgList(
        "",
        res => {
          this.loading = false;
          if (res.status === 200) {
            this.roleList = res.data;
          } else {
            this.$message.error(res.message);
          }
        },
        error => {
          this.loading = false;
          this.$message.error(this.$t("app_rqsError"));
        }
      );
    },
    onCancel: function() {
      this.$router.go(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// add.vue?09c7fc7d